import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input,
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';

import { DXCSource } from 'models';
import { derivedAsync } from 'ngxtension/derived-async';
import { BaseMenuComponent } from 'src/app/common/base-menu-component';
import { ArchivesService } from 'src/app/state/archives/archives.service';

/** DataXChange Sources Menu. */
@Component({
  selector: 'app-dxc-menu',
  templateUrl: './dxc-menu.component.html',
  styleUrls: ['./dxc-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DxcMenuComponent extends BaseMenuComponent {
  /** Archive Id. */
  archiveId = input.required<number>();
  /** Database Id. */
  databaseId = input.required<number>();
  /** Event emitted when a DXC source is selected. */
  @Output()
  dxcSourceSelected = new EventEmitter<DXCSource>();
  /** Array of DXC Sources. */
  sources = derivedAsync(
    () =>
      this.archiveService.api.getDataXChangeSources(
        this.databaseId(),
        this.archiveId()
      ),
    { initialValue: [] }
  );

  constructor(
    private logger: NGXLogger,
    private archiveService: ArchivesService
  ) {
    super();
  }

  /**
   * Handler for DXC Source on click event.
   *
   * @param source Source.
   */
  onClickDxcSource(source: DXCSource): void {
    this.logger.debug('Source clicked.', source);
    this.dxcSourceSelected.emit(source);
  }
}
